import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxFor } from '@rx-angular/template/for';
import { fadeAnimation } from "../animations/fade.animation";
import { MediaComponent } from '../media/media.component';
import { Media } from '../models/models';
import { rxState } from '@rx-angular/state';
import { map, Observable, tap } from 'rxjs';
import { ENVIRONMENT, IMAGE_STYLES, ImageStyles } from '../environment/environment';


@Component({
  selector: 'lib-carousel',
  standalone: true,
  imports: [CommonModule, MediaComponent, RxFor],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeAnimation]
})
export class CarouselComponent {

  private imageStyles = inject(IMAGE_STYLES);
  private url = inject(ENVIRONMENT).url;

  public state = rxState<{
    media: Media
  }>();
  public media$ = this.state.select('media').pipe(
    tap((media) => console.log('CarouselComponent media ', media)),

    // output is an Array so rxLet can animate it
    map((media) => ([{
      src: this.url + (media.bundle === 'image' ? media.media_image : media.media_video_file),
      srcset: media.bundle === 'image' ? this.buildSrcset(this.url + media.media_image) : '',
      sizes: media.bundle === 'image' ? this.imageStyles.backround_sizes['screen'] : '',
      type: media.bundle,
      alt: media.title,
    }]))
  );

  @Input()
  set media(media$: Observable<Media>) {
    this.state.connect('media', media$);
  }

  private buildSrcset = (src: string) => this.imageStyles.background_sizes_webp.
    map((size, index) => src.
    replace(this.imageStyles.replace_pattern, size).
    replace('.jpg', '.jpg.webp') 
    + ' ' + this.imageStyles.backround_sizes_img[index]).join(', ');

}
 
